import _ from 'lodash'
import { BaseDataItem, Logger, pointers, SiteAssetsHttpClient } from '@wix/thunderbolt-becky-types'
import type { BeckyFunctionLibrary, BeckyModel } from '@wix/thunderbolt-becky-root'

export type SvgItemsResolver = (
	data: BeckyModel['data'],
	{ mediaRootUrl }: BeckyModel['environmentTopology']
) => Promise<void>

export const resolveSvgItemsFactory = ({
	functionLibrary,
	fetch,
	logger,
}: {
	functionLibrary: BeckyFunctionLibrary
	fetch: SiteAssetsHttpClient['fetch']
	logger: Logger
}): SvgItemsResolver => {
	const fetchSvg = async (url: string, svgId: string) => {
		if (!url.endsWith('.svg') || !svgId) {
			return `<svg data-svg-id="fallback-${svgId}" />`
		}

		try {
			const res = await fetch(url)
			if (res.ok) {
				return res.text()
			}
			logger.error(new Error(`failed to fetch ${url}, received status code ${res.status} (${res.statusText})`))
		} catch (error) {
			logger.error(error)
		}
		return `<svg data-svg-id="fallback-${svgId}" />`
	}
	return (pageData, { mediaRootUrl }) =>
		functionLibrary.runAsyncAndReport(async () => {
			const results = _(pageData.document_data)
				.filter((item) => item.type === pointers.data.DATA_TYPES.SVG)
				.map(async (svgItem: BaseDataItem<string> & { svgId: string }) => {
					const url = functionLibrary.buildSvgUrl(mediaRootUrl, svgItem.svgId)
					const svgVal = await fetchSvg(url, svgItem.svgId)
					_.set(pageData.document_data, [svgItem.id, 'svgId'], svgVal)
				})
				.value()
			await Promise.all(results)
		}, 'tb-svgItems-resolving')
}
